// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.how {
  text-align: center;
}
.how .contact-list {
  color: #000000;
  font-family: "Open Sans";
  font-size: 14px;
  letter-spacing: 0;
  line-height: 19px;
  padding: 0 60px;
  text-align: left;
}
.how .label {
  font-size: 14px;
}
.how .card {
  align-items: center;
  margin-bottom: 40px;
  padding-bottom: 20px;
  background-color: #f5fbff !important;
  border: none;
  box-shadow: none;
}
.how .card .btn-primary {
  width: 325px;
}
.how .card li {
  padding-bottom: 14px;
}
.how .about-summary-info {
  border: 1px solid #b5b5b5;
  background-color: #fff;
  border-radius: 8px;
}

.about-header {
  width: auto;
  flex-grow: 0;
  font-family: "Open Sans";
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #414b4f;
  margin: 0px !important;
}

.about-summary {
  width: auto;
  height: auto;
  flex-grow: 0;
  margin: 16.7px 0 0;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  margin: 20px 0;
  color: #414b4f;
}

.about-summary-t {
  width: auto;
  height: auto;
  flex-grow: 0;
  margin: 16.7px 0 0;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: start;
  margin: 20px 0;
  color: #414b4f;
}

.about-summary-small {
  flex-grow: 0;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.58;
  letter-spacing: normal;
  text-align: left;
  color: #595e60;
  margin-bottom: 2px;
}

.btn-about {
  width: auto;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 8px 30px;
  border-radius: 4px;
  box-shadow: 0 4px 8px 0 rgba(10, 69, 91, 0.26);
  background-color: #00889b;
  flex-grow: 0;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/acds-about/HowCampWorks.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,cAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AACJ;AAEE;EACE,eAAA;AAAJ;AAGE;EACE,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oCAAA;EACA,YAAA;EACA,gBAAA;AADJ;AAGI;EACE,YAAA;AADN;AAII;EACE,oBAAA;AAFN;AAME;EACE,yBAAA;EACA,sBAAA;EACA,kBAAA;AAJJ;;AAQA;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AALF;;AAQA;EACE,YAAA;EACA,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,8CAAA;EACA,yBAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;AALF","sourcesContent":[".how {\n  text-align: center;\n\n  .contact-list {\n    color: #000000;\n    font-family: 'Open Sans';\n    font-size: 14px;\n    letter-spacing: 0;\n    line-height: 19px;\n    padding: 0 60px;\n    text-align: left;\n  }\n\n  .label {\n    font-size: 14px;\n  }\n\n  .card {\n    align-items: center;\n    margin-bottom: 40px;\n    padding-bottom: 20px;\n    background-color: #f5fbff !important;\n    border: none;\n    box-shadow: none;\n\n    .btn-primary {\n      width: 325px;\n    }\n\n    li {\n      padding-bottom: 14px;\n    }\n  }\n\n  .about-summary-info {\n    border: 1px solid #b5b5b5;\n    background-color: #fff;\n    border-radius: 8px;\n  }\n}\n\n.about-header {\n  width: auto;\n  flex-grow: 0;\n  font-family: 'Open Sans';\n  font-size: 20px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  text-align: center;\n  color: #414b4f;\n  margin: 0px !important;\n}\n\n.about-summary {\n  width: auto;\n  height: auto;\n  flex-grow: 0;\n  margin: 16.7px 0 0;\n  font-family: 'Open Sans';\n  font-size: 16px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  text-align: left;\n  margin: 20px 0;\n  color: #414b4f;\n}\n\n.about-summary-t {\n  width: auto;\n  height: auto;\n  flex-grow: 0;\n  margin: 16.7px 0 0;\n  font-family: 'Open Sans';\n  font-size: 16px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  text-align: start;\n  margin: 20px 0;\n  color: #414b4f;\n}\n\n.about-summary-small {\n  flex-grow: 0;\n  font-family: \"Open Sans\";\n  font-size: 14px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.58;\n  letter-spacing: normal;\n  text-align: left;\n  color: #595e60;\n  margin-bottom: 2px;\n}\n\n.btn-about {\n  width: auto;\n  height: 40px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 30px;\n  border-radius: 4px;\n  box-shadow: 0 4px 8px 0 rgba(10, 69, 91, 0.26);\n  background-color: #00889b;\n  flex-grow: 0;\n  font-family: 'Open Sans';\n  font-size: 16px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  text-align: center;\n  color: #ffffff;\n  text-decoration: none;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
